import Base from './Base';

class Timeline extends Base {
    get(query = null, page = null, count = null, opts = null) {
        return this.getJSONWithSession<ApiListResponse<Document>>(
            '/timeline',
            {
                ...(page !== null ? { page } : null),
                ...(count !== null ? { count } : null),
                ...query,
            },
            opts,
        );
    }

    future(query = null, page = null, count = null, opts = null) {
        return this.getJSONWithSession<ApiListResponse<Document>>(
            '/timeline/future',
            {
                ...(page !== null ? { page } : null),
                ...(count !== null ? { count } : null),
                ...query,
            },
            opts,
        );
    }

    recommendations(query = null, page = null, count = null, opts = null) {
        return this.getJSONWithSession<ApiListResponse<Document>>(
            '/timeline/recommendations',
            {
                ...(page !== null ? { page } : null),
                ...(count !== null ? { count } : null),
                ...query,
            },
            opts,
        );
    }

    past(query = null, page = null, count = null, opts = null) {
        return this.getJSONWithSession<ApiListResponse<Document>>(
            '/timeline/past',
            {
                ...(page !== null ? { page } : null),
                ...(count !== null ? { count } : null),
                ...query,
            },
            opts,
        );
    }

    create(url, opts = null) {
        return this.isBot
            ? Promise.resolve({ success: true })
            : this.postJSONWithSession<{ success: boolean }>(
                  '/timeline',
                  {
                      url,
                  },
                  opts,
              );
    }

    skip(url, opts = null) {
        return this.isBot
            ? Promise.resolve({ success: true })
            : this.postJSONWithSession<{ success: boolean }>(
                  '/timeline/skip',
                  {
                      url,
                  },
                  opts,
              );
    }
}

export default Timeline;
